import { render, staticRenderFns } from "./exhibition-template-service.vue?vue&type=template&id=ee5d1eb2&scoped=true&"
import script from "./exhibition-template-service.vue?vue&type=script&lang=js&"
export * from "./exhibition-template-service.vue?vue&type=script&lang=js&"
import style0 from "./exhibition-template-service.vue?vue&type=style&index=0&id=ee5d1eb2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee5d1eb2",
  null
  
)

export default component.exports